import { redirect } from "@tanstack/react-router";
import { authClient } from "./auth-client";
import { hasRole, type Role } from "./roles";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (session.user.role !== "admin") throw redirect({ to: "/home" });
  return session;
}

export async function requireClaimsOps() {
  const session = await requireAuth();
  const allowedRoles: Role[] = ["admin", "claims_ops"];
  if (!hasRole(session.user.role, allowedRoles)) throw redirect({ to: "/home" });
  return session;
}

export function requireRole(allowedRoles: Role[]) {
  return async () => {
    const session = await requireAuth();
    if (!hasRole(session.user.role, allowedRoles)) throw redirect({ to: "/home" });
    return session;
  };
}
